export const USD_SUBPATH = "";
export const GBP_SUBPATH = "/en-gb";
export const CAD_SUBPATH = "/en-ca";

export function getMarketSubpath(currency) {
  switch (currency) {
    case "GBP":
      return GBP_SUBPATH;
    case "CAD":
      return CAD_SUBPATH;
    default:
      return USD_SUBPATH;
  }
}

export function getBasePathname(pathname) {
  if (pathname.startsWith(GBP_SUBPATH))
    return pathname.slice(GBP_SUBPATH.length);
  if (pathname.startsWith(CAD_SUBPATH))
    return pathname.slice(CAD_SUBPATH.length);
  return pathname;
}
